export class PickingStrategyInfo {
    pickingStrategyID: string;
    pickingStrategyName: string;
    constructor() {
        this.pickingStrategyID = null;
        this.pickingStrategyName = null;
    }
}